import React from "react";
import {sizes} from "@unibuddy/machop/Experimental/General/components/Avatar/Avatar";
import MentorAvatar from "@unibuddy/machop/Mentor/components/MentorAvatar/MentorAvatar";
import InitialAvatar from "@unibuddy/machop/Applicant/components/InitialAvatar/InitialAvatar";

LiveEventAvatar.defaultProps = {
    size: "md",
};

export default function LiveEventAvatar({sender, className, size}) {
    switch (sender.accountRole) {
        case "mentor":
            return <MentorAvatar className={className} mentor={sender} size={size} />;

        case "staff":
            return <MentorAvatar className={className} mentor={sender} size={size} />;

        case "university":
            return <MentorAvatar className={className} mentor={sender} size={size} />;

        default:
            return (
                <InitialAvatar
                    className={className}
                    name={sender.firstName}
                    round
                    textSizeRatio={3.5}
                    size={sizes[size]}
                />
            );
    }
}
